import { Outlet, NavLink, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { Brand } from "../../components/Brand";
import { useSEO } from "../../lib/seo";

const NAV = [
    { to: "/admin", label: "Dashboard", end: true, testid: "adm-nav-dash" },
    { to: "/admin/visitors", label: "Visitors", testid: "adm-nav-visitors" },
    { to: "/admin/enquiries", label: "Enquiries", testid: "adm-nav-enquiries" },
    { to: "/admin/parts", label: "Parts", testid: "adm-nav-parts" },
    { to: "/admin/quotations", label: "Quotations", testid: "adm-nav-quotations" },
    { to: "/admin/tax-invoices", label: "Tax Invoices", testid: "adm-nav-invoices" },
    { to: "/admin/settings/billing", label: "Billing Settings", testid: "adm-nav-settings" },
    { to: "/admin/platform", label: "Platform", testid: "adm-nav-platform", superOnly: true },
    { to: "/admin/bookings", label: "Bookings", testid: "adm-nav-bookings" },
    { to: "/admin/technicians", label: "Technicians", testid: "adm-nav-tech" },
    { to: "/admin/customers", label: "Customers", testid: "adm-nav-cust" },
    { to: "/admin/users", label: "Users", testid: "adm-nav-users" },
    { to: "/admin/roles", label: "Roles & Permissions", testid: "adm-nav-roles" },
    { to: "/admin/services", label: "Services", testid: "adm-nav-svc" },
    { to: "/admin/coupons", label: "Coupons", testid: "adm-nav-coup" },
    { to: "/admin/payments", label: "Payments", testid: "adm-nav-pay-mgmt" },
    { to: "/admin/payouts", label: "Payouts", testid: "adm-nav-pay" },
    { to: "/admin/memberships", label: "Memberships", testid: "adm-nav-mem" },
    { to: "/admin/tickets", label: "Tickets", testid: "adm-nav-tic" },
    { to: "/admin/pgbooks", label: "PG Books", testid: "adm-nav-pg" },
];

export default function AdminLayout() {
    useSEO({ title: "Admin Console — LETS", noindex: true });
    const { user, logout } = useAuth();
    const nav = useNavigate();

    return (
        <div className="min-h-screen bg-[#0F0614] text-white lx-dark">
            <div className="flex min-h-screen">
                {/* Sidebar */}
                <aside className="hidden lg:flex w-64 bg-[#180A21] border-r border-[#2B1438] flex-col">
                    <div className="p-6 border-b border-[#2B1438]">
                        <Link to="/admin">
                            <Brand light size="small" />
                        </Link>
                        <div className="lx-label text-[#A09BA5] mt-3">
                            Admin Console
                        </div>
                    </div>
                    <nav className="flex-1 py-4">
                        {NAV.filter(
                            (item) => !item.superOnly || user?.role === "super_admin",
                        ).map((item) => (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                end={item.end}
                                data-testid={item.testid}
                                className={({ isActive }) =>
                                    `block px-6 py-3 text-sm transition border-l-2 ${
                                        isActive
                                            ? "border-[#D4AF37] text-[#D4AF37] bg-[#D4AF37]/5"
                                            : "border-transparent text-white/60 hover:text-white hover:bg-white/5"
                                    }`
                                }
                            >
                                {item.label}
                            </NavLink>
                        ))}
                    </nav>
                    <div className="p-4 border-t border-[#2B1438]">
                        <div className="text-xs text-white/60 mb-2">{user?.email}</div>
                        <div className="lx-label text-[#D4AF37] mb-3">{user?.role}</div>
                        <button
                            data-testid="adm-logout-btn"
                            onClick={async () => {
                                await logout();
                                nav("/login");
                            }}
                            className="text-xs text-white/60 hover:text-white"
                        >
                            ← Sign out
                        </button>
                    </div>
                </aside>

                {/* Main */}
                <main className="flex-1 min-w-0">
                    <header className="lg:hidden bg-[#180A21] border-b border-[#2B1438] px-4 py-3 flex justify-between items-center">
                        <Brand light size="small" />
                        <button onClick={logout} className="text-xs text-white/60">
                            Sign out
                        </button>
                    </header>
                    <div className="p-6 lg:p-10">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
}
